export default __webpack_public_path__ + "static/media/menu.1371c99c.svg";